module.exports = __webpack_public_path__ + "media/images/icons/country_flags/jm-46c20a3e99315fb4e78c99fb95623c68.svg";